export type DomainType = {
	id: string;
	name: string;
	isDefault: boolean;
};

export enum DomainConfigurationEnum {
	// general
	WIDGETS = 'Widgets',
	// document
	TAGS = 'Tags',
	// quickentry
	TEMPLATES = 'Modèles de pièces',
	CHECK_ISSUANCE_ACCOUNTS = 'Type de comptes "Chèques émis"',
	CHECK_REMITTANCE_ACCOUNTS = 'Type de comptes "Remise de chèques"',
	JOURNALS = 'Journaux',
	PAYMENT_MODES = 'Modes de règlement',
	BANKS = 'Banques',
}
